module.exports = __webpack_public_path__ + "img/Belegungsstelle.e11ceede.svg";